/**
 * NKBA API
 * The RESTful backend behind the NKBA application
 *
 * OpenAPI spec version: V1.0.0
 * Contact: cloud@nkba.org
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { AxiosRequestConfig } from 'axios';
import { axios } from '../axios.config';

import { Chapter } from '../models/Chapter';
import { Postal } from '../models/Postal';
import { ResultsPostalObjectId } from '../models/ResultsPostalObjectId';

/* tslint:disable:no-unused-variable member-ordering max-line-length */

export class PostalApiResource {

    /**
     * Return all postal codes, or search by a query string
     * 
     * @param q query search string
     * @param limit number of results to return
     */
    public getAll(query?: { q?: string, limit?: number }, axiosConfig?: AxiosRequestConfig): Promise<ResultsPostalObjectId> {
        const reqPath = '/v1/postal';
        let reqConfig = {
            ...axiosConfig,
            method: 'GET',
            url: reqPath,
            params: query
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

    /**
     * Return a particular chapter, by country and postal code
     * 
     * @param country country (two-letter ISO code)
     * @param postal postal code
     */
    public getChapterByPostal(country: Partial<string>, postal: Partial<string>, axiosConfig?: AxiosRequestConfig): Promise<Chapter> {
        const reqPath = '/v1/postal/postal/{country}/{postal}/chapter'
                    .replace('{' + 'country}', String(country))
                    .replace('{' + 'postal}', String(postal));
        let reqConfig = {
            ...axiosConfig,
            method: 'GET',
            url: reqPath
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

    /**
     * Return a particular postal code location
     * 
     * @param id Postal code id
     */
    public getPostal(id: Partial<string>, axiosConfig?: AxiosRequestConfig): Promise<Postal> {
        const reqPath = '/v1/postal/{id}'
                    .replace('{' + 'id}', String(id));
        let reqConfig = {
            ...axiosConfig,
            method: 'GET',
            url: reqPath
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

    /**
     * Return a particular postal code location, by country and postal code
     * 
     * @param country country (two-letter ISO code)
     * @param postal postal code
     */
    public getPostalByCountryPostal(country: Partial<string>, postal: Partial<string>, axiosConfig?: AxiosRequestConfig): Promise<Postal> {
        const reqPath = '/v1/postal/postal/{country}/{postal}'
                    .replace('{' + 'country}', String(country))
                    .replace('{' + 'postal}', String(postal));
        let reqConfig = {
            ...axiosConfig,
            method: 'GET',
            url: reqPath
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

    /**
     * Return a particular postal code location, by slug
     * 
     * @param slug slug
     */
    public getPostalBySlug(slug: Partial<string>, axiosConfig?: AxiosRequestConfig): Promise<Postal> {
        const reqPath = '/v1/postal/slug/{slug}'
                    .replace('{' + 'slug}', String(slug));
        let reqConfig = {
            ...axiosConfig,
            method: 'GET',
            url: reqPath
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

}

export const PostalApi = new PostalApiResource();



// WEBPACK FOOTER //
// ./src/common/api/resources/PostalApi.ts